import HundredBricksAPIError from '../../HundredBricksAPIError';
class SetFiscalZipCodeError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('SetFiscalZipCodeError', ...args);
    }
}
export default SetFiscalZipCodeError;
